module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/investments/hero-desktop-57acea4a65a6e0b565fd2e5cc4fa917d.png";